import { Phone, Mail, Instagram } from "lucide-react";
import QuoteModal from "@/components/QuoteModal";
import { NWFA_CREDENTIALS } from "@/data/credentials";

function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4l11.733 16h4.267l-11.733-16z" />
      <path d="M4 20l6.768-6.768M20 4l-6.768 6.768" />
    </svg>
  );
}

const socials = [
  { label: "Instagram", href: "https://www.instagram.com/1woodfloors/", icon: <Instagram className="w-[18px] h-[18px]" /> },
  { label: "Facebook", href: "https://www.facebook.com/1woodfloors/", icon: <FacebookIcon /> },
  { label: "TikTok", href: "https://www.tiktok.com/@1.wood.floors", icon: <TikTokIcon /> },
  { label: "X", href: "https://x.com/1woodfloors", icon: <XIcon /> },
];

// Short-form badge labels derived from the credentials.js source of truth.
const badges = [
  ...NWFA_CREDENTIALS.map((c) =>
    c
      .replace("NWFA Certified Wood Flooring Inspector", "NWFA Inspector")
      .replace("NWFA Certified ", "NWFA ")
  ),
  "MI Licensed Builder",
  "Fully Insured",
];

const FooterContact = () => (
  <div className="flex flex-col">
    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase mb-4"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Contact
    </span>

    <a
      href="tel:+12483258853"
      className="flex items-center gap-3 transition-colors duration-150"
      style={{ color: "var(--footer-text-primary)" }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <Phone className="w-3.5 h-3.5 shrink-0" style={{ color: "var(--footer-gold)" }} />
      <span className="text-[16px] font-semibold" style={{ letterSpacing: "-0.01em", fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif" }}>
        (248) 325-8853
      </span>
    </a>

    <a
      href="mailto:info@1woodfloors.com"
      className="flex items-center gap-2 text-[13px] mt-3 transition-colors duration-150"
      style={{ color: "var(--footer-text-secondary)" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-secondary)")}
    >
      <Mail className="w-3.5 h-3.5 shrink-0" style={{ color: "var(--footer-text-tertiary)" }} />
      info@1woodfloors.com
    </a>

    <div className="mt-7">
      <QuoteModal
        trigger={
          <button
            className="w-full text-[11px] font-medium rounded-[980px] py-[7px] px-4 text-center transition-all duration-200 cursor-pointer"
            style={{
              color: "var(--footer-gold)",
              border: "1px solid var(--footer-gold-border)",
              backgroundColor: "transparent",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "var(--footer-gold)";
              e.currentTarget.style.color = "#0d0d0d";
              e.currentTarget.style.borderColor = "transparent";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "var(--footer-gold)";
              e.currentTarget.style.borderColor = "var(--footer-gold-border)";
            }}
          >
            Request Consultation
          </button>
        }
      />
    </div>

    {/* Follow Us */}
    <div className="mt-7">
      <span
        className="text-[11px] font-semibold tracking-[0.08em] uppercase block mb-3"
        style={{ color: "var(--footer-text-tertiary)" }}
      >
        Follow Us
      </span>
      <div className="flex items-center gap-5">
        {socials.map((s) => (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Follow 1 Wood Floors on ${s.label}`}
            className="transition-all duration-150 hover:scale-110"
            style={{ color: "var(--footer-text-secondary)" }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-secondary)")}
          >
            {s.icon}
          </a>
        ))}
      </div>
    </div>

    {/* Badges */}
    <div className="grid grid-cols-2 gap-2 mt-6">
      {badges.map((badge) => (
        <span
          key={badge}
          className="rounded text-[8px] font-semibold tracking-[0.06em] uppercase text-center py-0.5 px-2"
          style={{
            color: "var(--footer-gold)",
            border: "1px solid var(--footer-gold-border)",
            backgroundColor: "var(--footer-gold-dim)",
          }}
        >
          {badge}
        </span>
      ))}
    </div>
  </div>
);

export default FooterContact;
